import {BehaviorSubject} from 'rxjs';
import type {B2BStaticPage} from '../apis/api-b2b.ts';

export const isB2bPage$ = new BehaviorSubject<boolean>(false);
export const b2bPageHierarchy$ = new BehaviorSubject<B2BStaticPage[]>([]);
